<template>
  <popup-modal ref="popup" class="box">
    <div class="d-flex justify-content-between align-items-center box-header">
        
        <h2 class="font-14">{{ title }}</h2>
        <span @click="_cancel" class="closeIcon"><i class="fa fa-times"></i></span>
    </div>
    <p class="font-14 p-4" v-html="message"></p>
    <div class="footer_buttons mb-4">
      <b-button v-if="cancelButton" class="rounded cancel-btn btn-secondary text-uppercase" @click="_cancel">{{ cancelButton }}</b-button>
      <b-button class="rounded ok-btn text-uppercase ml-md-3 mt-3" @click="_confirm">{{ okButton }}</b-button>
    </div>
  </popup-modal>
</template>

<script>
// import PopupModal from './PopupModal.vue'

export default {
  name: 'ConfirmDialogue',

  components: {
    PopupModal: () => import(/*webpackChunkName: "PopupModal"*/ './PopupModal')

  },

  data() {
    return {
      // Parameters that change depending on the type of dialogue
      title: undefined,
      message: undefined, // Main text content
      okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
      cancelButton: 'CANCEL', // text for cancel button

      // Private variables
      resolvePromise: undefined,
      rejectPromise: undefined,
    }
  },

  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.okButton = opts.okButton
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
}
</script>

<style scoped lang="scss">
@import "../scss/_variable";

* {
    padding: 0;
    margin: 0;
}
.box {

//   padding: 1rem;
}

.box-header {
    background-color: #E5E5E5;
    padding: 10px 25px;
}
span.closeIcon {
//   float: right;
  cursor: pointer;
  color: #8c8c8c;
}

h2, p {
  color: rgba(88, 88, 88, 0.87);
}

h2 {
    font-size: 16px;
}

p {
    font-size: 12px;
    white-space: pre-line;
}

.footer_buttons {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  button {
    width: 135px;
    height: 42px;

    &:hover {
      background-color: $hover-color !important;
      border-color: $hover-color !important;
      color: $background-color !important;
    }
  }

  .ok-btn {
    background-color: $theme-color !important;
    color: #ffffff !important;
    border-color: $background-color !important;
  }

  .cancel-btn  {
    background-color: #ffffff !important;
    color: $theme-color !important;
    border-color: $theme-color !important;
  }
}

@media only screen and (max-width: 540px) {
  .footer_buttons {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    button {
      width: 175px;
    }

    .ok-btn {
      margin-bottom: 1rem;
    }
  }
}

@media only screen and (min-width: 1080px) {
  .ok-btn {
    margin-right: 0.75rem;
  }
}

</style>
